// @ts-nocheck
import { Text, View, StyleSheet, Svg, Path, G } from '@react-pdf/renderer'
import { Product as ProductType } from 'type'
import { TenYearIcon } from './10y'
import { IlluIcon } from './illu'
import React from 'react'

interface Props {
  product: ProductType
  idx: number
  color?: string
  fontSizePercentage?: number
  specialProductSVG?: string
}

const SVGComponents = {
  '10y': TenYearIcon,
  illu: IlluIcon
  // Ajoutez ici d'autres composants SVG au besoin
}

export const Product: React.FC<Props> = ({ product, color, fontSizePercentage, specialProductSVG }) => {
  const FONT_SIZE_RATIO = fontSizePercentage || 100
  const adjustFontSize = (size) => `${(size * FONT_SIZE_RATIO) / 100}pt`

  const styles = StyleSheet.create({
    section: {
      width: '100%'
    },
    flex: {
      display: 'flex',
      width: '100%'
    },
    row: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'space-between'
    },
    rowBambini: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
    product: {
      width: '100%'
    },
    label: {
      textTransform: 'uppercase',
      fontSize: adjustFontSize(7),
      fontFamily: 'saa-e-d',
      letterSpacing: '0.5px'
    },
    logo: {
      width: '8%'
    },
    description: {
      fontFamily: 'prestige-elite-bold',
      paddingLeft: '3px',
      fontSize: adjustFontSize(8),
      paddingRight: '5px',
      paddingTop: '-1px',
      lineHeight: '1.1'
      // marginBottom: '10px'
    }
  })

  const isBambini = product.label === 'Pasta Bambini'

  const splitTitle = (title) => {
    if (title.length <= 75) return [title]
    const firstPart = title.slice(0, 75)
    const lastSpaceIndex = firstPart.lastIndexOf(' ')
    if (lastSpaceIndex === -1 || title[75] === ' ') {
      return [firstPart, title.slice(75).trim()]
    }
    return [firstPart.slice(0, lastSpaceIndex), title.slice(lastSpaceIndex + 1)]
  }

  const [firstLine, secondLine] = splitTitle(product.label)

  console.log('specialProductSVG', specialProductSVG)
  if (isBambini) {
    return (
      <View style={styles.section} key={product.label}>
        <View style={styles.flex}>
          <View style={styles.product}>
            <View
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                width: '100%'
              }}
            >
              <View style={{ marginRight: '8px', width: '33px', height: '33px', backgroundColor: 'lightgray' }}>
                <Svg width={33} height={33} viewBox="0 0 38.57 31.92">
                  <G>
                    <Path
                      fill={color}
                      d="m35.11 20.1c-3.13 1.93-3.23 2.38-3.94 5.89-1.07 1.78-3.66.78-5.39 1.23-4.35.55-8.6.06-12.93.19 1.89-1.33.81-5.72 3.05-6.43 1.83.16 3.99-.42 5.59.67 1.31 1.06 2.86 2.15 4.59 1.35 1.37-.19 2.35-1.06 3.16-1.85 1.48-.24 4.94.24 4.7-2.05-.1-.68 1.82.65 1.17 1m-17.81.42c-.4-.03-.79-.01-1.21-.02.26-.21.71-.85 1-.68.04.23.1.46.21.7m-4.59 6.71c-1.11 1.19-3.11 2.44-4.63 2.11-.01-1.4 1.77.44 4.22-2.85 1.06-1.18 1.12-3.67 1.32-4.96.47-1.41 2.07-3.41 3.57-3.06-.35 1.41-.21.61-1.13 1.53-2.71 1.97-1.49 4.96-3.35 7.23m-3.06-.08c-3.25.37-2.9-3.28-3.71-5.42-.4-1.08-1.7-1.08-2.39-1.88-.75-.83.45-1.4 1.2-1.34-1.48 3.19 6.8 2.63 8.54 2.56-.18 2.01-.33 4.72-2.19 6.17-.45.1-.97-.07-1.45-.09m-3.38-9.35c1.54-1.08 3.54-2.07 5.33-1.01.2.08-.25.34-.27.49-.02.03-.03.07-.08.03-2.1-.38-4.74.45-5.68 2.53-.06.17-.23-.06-.34-.08-.29-.1-.29-.47-.31-.74.21-.61.88-.85 1.35-1.22m6.38-3.14c.98-.1 3.41.04 1.29.97-.28-.62-1.25-.2-1.75-.1-.7.28-1.27.62-2.04.36.67-.75 1.53-1.17 2.5-1.23m2.08-1.09c.41-.06 1 0 1.3.2-.05.23.02.58-.13.75-.26-.03-.52.12-.74.15-.45-.39-1.01-.38-1.58-.43.36-.29.69-.59 1.15-.67m1.39 2.06c.08-.13.19-.15.33-.13.49.07.95-.09 1.4-.25.61-.18.78-.1 1.22.61-1 .55-2.37.34-3.53.22.19-.15.4-.28.58-.45m-1.28-8.88c-.48-.12-1.13-.03-1.53-.29-.03-.25.34-.2.47-.33.24-.31-.4-.17-.52-.28-.14-.08-.15-.34.06-.33 1.25.19-.11-.62.34-.63.28.02.64.26.66-.18.04-.16.22.07.34.02.58.06.93.49 1.3.89.55.5 2.07.25 1.69 1.36-.56 2.59 1.62 5.07.8 7.69-.02.07-.04.11-.12.1-.69-.01-1.3.46-2 .32-.09-.01-.11-.05-.09-.15.26-1.15.25-2.42.16-3.55-.02-.75-.08-1.77-.14-2.52-.06-.87-.49-1.91-1.42-2.12m3.91 7.98c.19-.52-.04-1.08.73-1 .58-.08-.11.85-.11 1.15-.05.18-.35.34-.47.14-.09-.1-.24-.14-.15-.29m1.56.6c.74.08 1.63.14 2.16.73-.88-.06-1.38.75-2.02 1.1-.15-.45-.37-.89-.86-1.04-.18-.11-.07-.42-.25-.58.05-.26.71-.18.97-.21m2.31.1c.83.47 3.25-.34 3.23.63.09.93-3.59.44-3.23-.63m.12 1.02c.92.39 4.19 1.07 3.29-.87-.4-.95-3.99.54-3.36-1.1 1.15.32 2.48-.51 3.64.02 1.6.46 1.35 2.99-.38 2.94-1.37-.01-3.09-.82-4.22.26-.1.17.22.22.11.39-.41.41-1.13-.12-1.75.43.36-1 1.51-2.23 2.67-2.07m4.88.52c.21-.39.33-.8.28-1.24-.01-.05-.01-.08.06-.07.92 0 1.98-.12 2.62.71.12.07.24.48.05.47-1.73-.56-2.99 1.05-4.61 1.27-.37.08-3.97.19-3.57-.27 1.58-.74 4.1 1.15 5.17-.87m-17.54 3.62c.94-.59 2.1-.56 3.04-1.12.44-.25.49-.77.83-1.12.95-.83 2.51-.55 3.67-.42-.1.06-.15.17-.26.16-1.6-.21-2.97 1.14-3.73 2.41-1.14.26-2.44.19-3.64.16.02-.04.06-.05.09-.07m8.09-4.04c.77-.38 1.67-.18 1.93.72-2.33.25-.72.46-1.93-.72m-10.28 3.58c1.23-1.56 3.36-1.21 4.97-1.83.77-.94 1.65-1.99 3.01-1.8.82.16 2.24-.08 2.43 1.02.01.18-.28.17-.4.26-.64-.53-1.74-.29-2.58-.32-1.13-.05-1.84.74-2.34 1.61-1.09.54-2.38.57-3.36 1.38-.59.35-1.34-.01-1.98-.02.08-.11.16-.21.25-.3m3-2.34c-.53.59-1.27.7-1.97.97-.65.4-1.3.9-1.71 1.56-.4.11-.94-.15-1.36-.25-.05-.44.84-1.14 1.2-1.5 1.14-.76 2.64-1.01 3.97-.88 0-.01-.12.08-.13.1m1.05-1.3c-.2-.11-.4-.14-.61-.25.68-.28 1.33-.54 2.06-.52 0 .01 0 .02.01.03-.54.12-.99.62-1.46.74m1.33-.17c.66-.32 1.42-.53 1.88-1.14.08-.1.4-.42.47-.25-.05.16-.04.35.14.41-.5.85-2.18 1.13-2.75 2.19-.44.84-1.23.76-2.04.74.88-.51 1.25-1.62 2.3-1.95m6.13 2.86c-.92.19-1.4.39-1.68 1.36-1.14-2.04.48-2.88 2.39-2.87-.5.38-.38 1.05-.71 1.51m.04 1.28c-.29.15-.86-.01-1.24.03.08-.54.57-.97 1.12-.84.19.17-.02.58.12.81m11.87-2.49c.18.28.38.59.36.93-1.21-1.23-2.69-.17-3.91.41-2.64.56-5.69-1.28-7.95.8-.18-1.76 1.56-1.17 2.5-1.68 1.2-.01 2.46.31 3.69.09 1.81-.17 3.79-2.69 5.31-.55m.58.24c.44.06.72 1.67.23 1.2-.27-.24-.06-.36-.07-.62-.02-.2-.08-.39-.16-.58m-4.93 2.81c-1.36 1.19-2.66.63-3.85.14 1.27-.02 2.58-.28 3.85-.14m-.24-.56c-1.28 0-2.58.12-3.86.22-.6-.08-.98-.65-1.45-.97 2.24-.7 4.63.79 6.87-.09-.4.59-.79 1.12-1.56.84m4.35.1c-.51.03-1.01.06-1.52.1.5-.14 1-.28 1.52-.1m-.87-.48c-2.11.3-1.04 2.86-6.13 2.71-1.49-.52-2.51-2.07-4.16-2.16.22-.31.51-.55.86-.68 1.44 1.32 3.08 2.57 5.1 2.05 1.45-.15 2.45-1.93 3.18-2.71 1.77-1.85 2.47 1.18 4.13.76-.96.92-1.91-.25-2.98.03m3.32-1.76c.19.74.33 1.59-.74 1.28-.14-1.93-.89-1.41-1.73-2.52.4-.77 2.1.74 2.47 1.24m1.88.96c-.38-.43-.92-.61-1.44-.78-.53-.98-1.6-1.89-2.76-1.99-.68-1.03-1.48-1.45-2.79-1.24-1.5.07-.57-2.01-4.53-1.12-.33.14-.65-.05-.98-.04-.05 0-.07-.01-.05-.07.54-1.65-.19-4.16-.14-5.89-.38-.92 1.45-5.17.15-4.99.01-.47-.57-.61-.44-.04.16.34-.24.8.02 1.05.34.03.34-.44.43-.69.26 1.32-.59 2.59-.59 3.92 0 .61.41 4.96.41 5.47.04.89-.64 1.63-.43 2.53-.73-.47-1.85-.39-2.5-.54.79-2.04.94-4.6.94-6.78-.21-.68.22-1.34.23-2.01.07-.8-.26-1.59-.01-2.38.03-.19.27-.91.47-.53.11.24.1.48.01.73.15.82.57-.59.27-.89-.58-.9-1.15.52-1.15 1.07-.11.77.22 1.54.07 2.33-.23.65-.35 1.24-.21 1.93-.07 1.53-.14 3.74-.62 5.12-1.32-.14-.62.17-.88-1.18-.26-1.46-1.19-3.22-.97-4.72.07-.56.38-1.3-.25-1.65-.53-.37-1.3-.24-1.7-.82-.33-.48-1.71-1.19-2.07-.56-.01.06-.03.07-.08.06-.36-.11-.81.19-.58.58-.62.08-.52.65-.26 1.01-.47 1.53 2.19.44 2.61 1.54.38.54.38 1.21.39 1.84-.08 1.42.27 2.91.01 3.86-1.03-.61-2.12 0-2.91.72-.93.35-2.12.27-2.78 1.2-.93 1.02-2.58.85-3.64 1.77-.77.54-1.42 1.21-2.42 1.11-.97.05-1.78 1.07-.99 1.9.64.88 2.1.76 2.44 1.87.88 3.52.39 5.75 4.88 5.72-.67.56-1.55.75-2.4.74-.48-.02-.29.53-.41.83-.52 1.14 2.78-.03 3.2-.24.72-.24 1.18-1.03 1.84-1.21 1.45.06 3.11-.01 4.58.07 3.36.24 6.71-.03 10.06-.32 1.87 0 4.28.04 4.35-2.46-.07-4.16 4.93-4.02 3.62-5.83"
                    />
                    <Path fill={color} d="m22.18 2.71c-.59-.56-.25.69-.19.96.42.54.36-.76.19-.96" />
                    <Path
                      fill={color}
                      d="m24.16 5.83c.02.01.04.01.06.01.08 0 .16-.05.18-.13.31-.98.38-2.04.22-3.05-.02-.11-.12-.18-.22-.16-.11.02-.18.12-.16.22.16.96.08 1.95-.21 2.87-.03.1.03.21.13.24"
                    />
                    <Path
                      fill={color}
                      d="m25.21 5.27c.02 0 .03.01.05.01.09 0 .16-.06.19-.14.13-.5.17-1.01.11-1.53-.01-.1-.1-.18-.21-.17s-.18.11-.17.21c.05.47.01.93-.1 1.39-.03.1.03.21.13.23"
                    />
                  </G>
                </Svg>
              </View>

              <View
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  marginTop: '1px'
                }}
              >
                <View
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    width: '100%',
                    justifyContent: 'space-between'
                  }}
                >
                  <Text style={styles.label}>{firstLine}</Text>
                  {secondLine && <Text style={styles.label}>{secondLine}</Text>}
                  <Text
                    style={{
                      borderBottom: `1px dotted ${color}`,
                      flexGrow: 1,
                      margin: '-1px 5px 0px 5px'
                    }}
                  ></Text>
                  <Text
                    style={{
                      textTransform: 'uppercase',
                      fontSize: adjustFontSize(7.5),
                      fontFamily: 'prestige-bold'
                    }}
                  >
                    {product.price}
                  </Text>
                </View>
                <Text
                  style={{
                    marginTop: '3px',
                    paddingLeft: '3px',
                    width: '100%'
                  }}
                >
                  {product.description}
                </Text>
              </View>
            </View>
          </View>
        </View>
      </View>
    )
  }
  return (
    <View style={styles.section} key={product.label}>
      <View style={styles.flex}>
        <View style={styles.product}>
          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
              alignItems: 'center',
              marginBottom: '10px'
            }}
          >
            {product.isSpecial && specialProductSVG && (
              <View style={{ marginRight: '4px', marginLeft: '-15px' }}>
                {SVGComponents[specialProductSVG] &&
                  React.createElement(SVGComponents[specialProductSVG], {
                    color,
                    width: 30,
                    height: 30
                  })}
              </View>
            )}
            <View style={{ flex: 1, justifyContent: 'center' }}>
              <View style={styles.row}>
                <Text style={{ ...styles.label }}>{product.label}</Text>
                <Text
                  style={{
                    borderBottom: `1px dotted ${color}`,
                    flexGrow: 1,
                    margin: '4px 5px 0px 5px'
                  }}
                ></Text>
                <Text style={styles.label}>{product.price}</Text>
              </View>
              <Text style={styles.description}>{product.description}</Text>
            </View>
          </View>
        </View>
      </View>
    </View>
  )
}
